import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const menuSelectionSlice = createSlice({
    name: 'menuSelection',
    initialState: {
        menuId: 'chat',
    },
    reducers: {
        setMenuSelection(state, action: PayloadAction<any>) {
            state.menuId = action.payload;
        }
    }
});

export const { setMenuSelection } = menuSelectionSlice.actions;

export default menuSelectionSlice.reducer;
